export default __webpack_public_path__ + "static/media/Wolf's Mask of the Howling Wind.cba3b814.jpg";